import { useQuery } from '@tanstack/react-query';
import api from 'services/api/api';

export const getUserById = async ({ queryKey }) => {
	const [, id] = queryKey;
	const url = `/usuario/usuarioById?usuario_id=${id}`;
	const response = await api.get(url);
	return response.data;
};

export const useGetUsersById = (id: number, setSelectedUserTypes: any) => {
	return useQuery(['userById', id], getUserById, {
		onSuccess: data => {
			setSelectedUserTypes(
				data.perfil?.map(type => {
					return {
						value: type.grupo_usuarios?.id,
						label: type.grupo_usuarios?.descricao,
					};
				})
			);
		},

		refetchOnWindowFocus: false,
	});
};
